import { computed, observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import { getOmniData, newData } from '@src/services/omni-api';
import createHtmlLink from '@src/utils/create-html-link';
import buildRouteUrl, { isAbsoluteUrl } from '@src/utils/build-route-url';
import $$tracker from '@src/tracker';
import AntdMessage from '@src/components/antd/message';

const styles = require('./index.less');

let swiperRef = null;
class NewsStore {
  @observable config = {};
  @observable isActive = false;
  @observable newsImgList = [];
  @observable currentIndex = 0;

  @observable newTabList = newData;
  @observable currentTab = 0;
  @observable allData = {};
  @observable newList = [];
  @observable topId = 'ds_cat_f4244f78'; // 置顶数据
  @observable topData = {};
  @observable newChennelInfo = {};
  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      on: {
        init: function() {
          swiperRef = this;
        },
        // resize: function() {
        //   console.log(333);
        //   swiperRef?.update();
        // },
        slideChange: function() {
          that.currentIndex = this.realIndex;
        },
        click: function() {
          $$tracker.clickJhkbLunbotu(that.newsImgList[that.currentIndex]?.title || '');
          that.gotoDetail(that.newsImgList[that.currentIndex]);
        }
      }
    };
  }

  changeSwiper = index => {
    if (index === 'prev') {
      swiperRef.slidePrev();
      return;
    }
    if (index === 'next') {
      swiperRef.slideNext();
      return;
    }
    if (index === this.currentIndex) {
      return;
    }
    swiperRef.slideTo(index + 1);
  };

  changeTab = (index, item) => {
    $$tracker.clickJhkbNav(item.title);
    if (index === this.currentTab) {
      return;
    }
    this.currentTab = index;
    this.newList = this.formatNewsData(this.allData[this.newTabList[this.currentTab].id]);
  };

  /**
   * 获取轮播数据
   */
  getNewsImgList = async () => {
    try {
      // 轮播图
      const res = await getOmniData('channel_cat_e9f08e88', [
        {
          dataSourceId: 'ds_cat_e490b7bd' || '',
          page: 1,
          perPage: 10
        }
      ]);
      if (res.ds_cat_e490b7bd.result?.items) {
        this.newsImgList = res.ds_cat_e490b7bd.result?.items.map(item => {
          return {
            ...item,
            title: item.title || '',
            url: item.rotating_chart[0]?.url || '',
            contentId: item.contentId || ''
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  getNewsChennelList = async () => {
    try {
      // 轮播图
      const res = await getOmniData('channel_cat_e9f08e88', [
        {
          dataSourceId: 'ds_cat_a8ffb6a9' || '',
          page: 1,
          perPage: 10
        }
      ]);
      if (res.ds_cat_a8ffb6a9.result?.items?.[0]) {
        this.newChennelInfo = res.ds_cat_a8ffb6a9.result?.items?.[0] || {};
      }
    } catch (error) {
      console.log(error);
    }
  };
  openNewTab = key => {
    if (!this.newChennelInfo[key]) {
      AntdMessage.error('链接不存在');
      return;
    }
    const link = createHtmlLink(this.newChennelInfo[key]);
    link.target = '_blank';
    link.click();
  };
  /**
   * 获取快讯数据数据
   */
  getNewsList = async () => {
    try {
      // 轮播图
      const dataSources = this.newTabList.map(tab => {
        return {
          dataSourceId: tab.id || '',
          page: 1,
          perPage: 10
        };
      });
      dataSources.push({
        dataSourceId: this.topId || '',
        page: 1,
        perPage: 10
      });
      const res = await getOmniData('channel_cat_e9f08e88', dataSources);
      this.allData = res || {};
      this.newList = this.formatNewsData(this.allData[this.newTabList[this.currentTab].id]);
      this.topData = this.allData[this.topId]?.result?.items?.[0] || {};
    } catch (error) {
      console.log(error);
    }
  };

  formatNewsData = data => {
    return data.result?.items || [];
  };

  gotoDetail = item => {
    if (!item) {
      return;
    }
    const jumpLink = typeof item.jump_link === 'string' ? item.jump_link.trim() : '';
    if (jumpLink === 'stay') {
      return;
    }
    let url = '';
    if (isAbsoluteUrl(jumpLink)) {
      // 轮播图等条目由 CMS 直接配置完整链接(已带正确的 contentId/categoryId), 直接使用
      url = jumpLink;
    } else if (jumpLink === 'link') {
      url = item.art_link?.url || item.silder_link?.url || '';
    } else {
      // hash 路由: 参数必须拼在 #/news-detail 之后, 否则前端路由取不到
      url = buildRouteUrl('/news-detail', {
        contentId: item.contentId,
        categoryId: this.newTabList[this.currentTab].id,
        page: 1
      });
    }
    if (!url) {
      return;
    }
    const link = createHtmlLink(url);
    link.target = '_blank';
    link.click();
  };

  gotoNewsList = () => {
    const url = buildRouteUrl('/news-list', { categoryId: this.newTabList[this.currentTab].id });
    const link = createHtmlLink(url);
    link.target = '_blank';
    link.click();
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.getNewsImgList();
      this.getNewsList();
      this.getNewsChennelList();
      let timer = null;
      window.addEventListener('resize', () => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          swiperRef?.update();
          clearTimeout(timer);
        }, 1000);
      });
    });
  }
}

export default NewsStore;
